import { render } from "./CobaltSubTaskForm.vue?vue&type=template&id=5b1adb22"
import script from "./CobaltSubTaskForm.vue?vue&type=script&lang=js"
export * from "./CobaltSubTaskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__